import { gql } from '@apollo/client'

export const FIND_ONE_EMAIL_TEMPLATE = gql`
  query FindOneEmailTemplate($type: EmailTemplateTypeEnum!, $platform: LinkPlatformInput) {
    findOneEmailTemplate(type: $type, platform: $platform) {
      id
      title
      type
      subject
      emailAsHtml
      config {
        isDisabledForAdmins
        isDisabledForUsers
        is2DaysPriorEnabled
        is7DaysPriorEnabled
      }
      platform {
        id
      }
    }
  }
`

export const UPDATE_EMAIL_TEMPLATE = gql`
  mutation UpdateEmailTemplate($updateEmailTemplateInputFieldName: UpdateEmailTemplateInput!) {
    updateEmailTemplate(updateEmailTemplateInputFieldName: $updateEmailTemplateInputFieldName) {
      id
      title
      type
      subject
      emailAsHtml
      config {
        isDisabledForAdmins
        isDisabledForUsers
        is2DaysPriorEnabled
        is7DaysPriorEnabled
      }
    }
  }
`

export const SEND_EMAIL = gql`
  query SendEmail($input: SendEmailInput!) {
    sendEmail(input: $input) {
      isDone
    }
  }
`
